import { apiClient } from "services/api-client"

export const getUsersGroups = async (tenant) => {
    return await apiClient.get(`/user/group/by-tenant/${tenant}`)
}

export const getUsersGroupsPaged = async (tenant, page, perPage) => {
    return await apiClient.get(`/user/group/paged?companyKey=${tenant}&page=${page}&perPage=${perPage}`)
}

export const getUsersGroupById = async (id) => {
    return await apiClient.get(`/user/group/${id}`)
}

export const addUsersGroup = async (userGroup) => {
    return await apiClient.post('/user/group', userGroup)
}

export const editUsersGroup = async (id, userGroup) => {
    return await apiClient.put(`/user/group/${id}`, userGroup)
}

export const deleteUsersGroup = async (id) => {
    return await apiClient.delete(`/user/group/${id}`)
}

export const updateUsersGroupUsers = async (id, users) => {
    return await apiClient.put(`/user/group/${id}/users`, { users })
}

export const getUsersGroupUsers = async (id) => {
    return await apiClient.get(`/user/group/${id}/users`)
}